import { useAccountType, usePermission, useUser } from "@js/apps/common/hooks";

export const useCanAddTeamMembersToJob = (jobOwnerId: number | undefined) => {
  const { isEmployer } = useAccountType();
  const user = useUser();
  const canManageAllJobs = usePermission(
    ENUMS.CustomPermission.CAN_MANAGE_ALL_EMPLOYER_JOBS,
  );
  const isJobOwner = !!user && user?.id === jobOwnerId;
  const canManageThisJob = canManageAllJobs || isJobOwner;
  const canAddTeamMembersToJob = isEmployer && canManageThisJob;

  return { canAddTeamMembersToJob };
};
